<template lang="pug">
q-dialog(
    full-width
    position="bottom"
    transition-show="slide-up"
    transition-hide="slide-down"
    :model-value="showAnotherCities"
    @hide="hideDialog()")
    .bg-secondary.q-py-lg.q-px-md.text-primary.relative-position.full-width
        q-btn.absolute-top-right.z-top.q-ma-sm(
            flat
            round
            dense
            v-close-popup)
            q-icon(
                size="14px"
                name="etabl:cross"
                color="grey")
        .q-py-sm.font-13.line-height-20.text-center
            span Населенные пункты, где
            span.text-positive.text-weight-medium &nbsp;{{ currentSearch }}&nbsp;
            span  в наличии
        .q-pt-lg
            .font-16.line-height-18.text-weight-medium.q-mb-md 
                | Выберите регион
            .q-pb-sm.q-pl-md(v-for="region in regions" @click="changeRegion(region)" :class="region == currentRegion ? 'text-positive' : ''")
                | {{ region.name }}
            .font-16.line-height-18.text-weight-medium.q-mb-md 
                | Населенный пункт
            .q-pb-md
                q-scroll-area(style="height: 300px")
                    .q-pb-sm.q-pl-md(v-for="city in currentRegion.cities" @click="setCity(city)" :class="city == currentCity ? 'text-positive' : ''")
                        | {{ city.name }}
        base-btn(
            :disable="!currentCity"
            :label="currentCity ? 'Найти' : 'Выберите населённый пункт'"
            height="40"
            bradius="16"
            @click="changeCity"
        )
</template>

<script>
import { useRoute, useRouter } from 'vue-router';
import { computed, ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useQuasar, LocalStorage } from 'quasar';
import { async } from 'vue-phone-number-input/dist/vue-phone-number-input.common';

import BaseBtn from '../Base/BaseBtn.vue';

export default {
    props: {
        regions: {
            type: Array,
            required: true,
        },
        showAnotherCities: {
            type: Boolean,
            default: () => false,
        },
    },
    components: {
        BaseBtn,
    },
    setup(props, { emit }) {
        const route = useRoute();
        const store = useStore();
        const router = useRouter();
        const $q = useQuasar();

        const currentRegion = ref(null);
        const currentCity = ref(null);

        const hideDialog = () => {
            emit('hideCities');
        };

        const currentSearch = computed(() => route.query.query);

        const changeRegion = (region) => {
            currentRegion.value = region;
            currentCity.value = null;
        };

        const setCity = (city) => {
            currentCity.value = city;
        };

        const changeCity = async () => {
            store.commit('catalog/SET_CATALOG_SCROLL_ID', null);

            try {
                await store.dispatch('user/UPDATE_USER_CITY_ID', currentCity.value.id);
                if (process.env.CLIENT) {
                    LocalStorage.set('USER_CITY_ID', currentCity.value.id);
                }

                let redPath = '';

                if(currentCity.value.slug == 'belgorod') {
                    if(route.params.city != '') {
                        redPath = route.fullPath.replace(`/${route.params.city}/`, '/');
                    } else {
                        redPath = `/${currentCity.value.slug}${route.fullPath}`;
                    }
                    redPath = route.fullPath.replace(`/${route.params.city}/`, '/');
                        
                } else {
                    if(route.params.city != '') {
                        redPath = route.fullPath.replace(`/${route.params.city}/`, `/${currentCity.value.slug}/`);
                    } else {
                        redPath = `/${currentCity.value.slug}${route.fullPath}`;
                    }
                }

                await router.replace({ path: `${redPath}`, query: {...route.query}});

                if (process.env.CLIENT)
                    window.location.reload(true);
            } catch (e) {

                $q.notify({
                    color: 'negative',
                    message: 'Произошла ошибка. Повторите попытку позже',
                });
            }
        };

        onMounted(() => {
            if(props.regions) {
                currentRegion.value = props.regions[0];
            }
            
        });

        return {
            hideDialog,
            currentSearch,
            currentRegion,
            currentCity,
            changeRegion,
            setCity,
            changeCity,
        };
    },
};
</script>

<style lang="scss" scoped>


</style>
